import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { GroupMemberModel } from '@app/interface/groupMember.model';
import { UserService } from '@app/services/user.service';
import { SurveyAnswerService } from '@app/surveyAnswers/surveyAnswers.service';

@Component({
  selector: 'app-user-list-table',
  templateUrl: './userList.component.html',
  styleUrls: ['./userList.component.scss'],
})
export class UserListTableComponent implements OnInit {
  @Input() isLoading = false;
  @Input() message: string;
  @Input() dataTable: GroupMemberModel[] = [];
  @Input() dataColumn: string;
  first = 0;
  rows = 5;
  values = '';
  @Input() isDefaultStudy: boolean;

  constructor(
    public userService: UserService,
    public surveyAnswerService: SurveyAnswerService,
    private router: Router
  ) {}

  getIndex(arr: any, activity: any) {
    let index = arr.map((item: any) => item.id).indexOf(activity['id']);
    return index;
  }

  ngOnInit() {
    this.dataTable = [];
  }

  getUserSurveys(userId: string): void {
    this.surveyAnswerService.setUserId(userId).subscribe(() => {
      this.router.navigate(['/user-survey']);
    });
  }

  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.dataTable ? this.first === this.dataTable.length - this.rows : true;
  }

  isFirstPage(): boolean {
    return this.dataTable ? this.first === 0 : true;
  }
}
